"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var use_global_hook_1 = __importDefault(require("use-global-hook"));
var initialState = {
    session: 'dinner',
};
var setSession = function (store, session) {
    store.setState({ session: session });
};
var sessionActions = {
    setSession: setSession,
};
var useGlobal = (0, use_global_hook_1.default)(react_1.default, initialState, sessionActions);
var useAvailabilitySession = function () {
    var _a = useGlobal(), session = _a[0], actions = _a[1];
    return __assign(__assign({}, session), actions);
};
exports.default = useAvailabilitySession;
//# sourceMappingURL=availabilitySession.js.map